/**
 * TypeScript types for lookup table management
 */

/**
 * Lookup item returned from API
 */
export interface LookupDto {
  id: number;
  name: string;
  isActive: boolean;
  sortOrder: number;
}

/**
 * Request payload for creating a new lookup item
 */
export interface CreateLookupRequest {
  name: string;
  sortOrder?: number;
}

/**
 * Request payload for updating a lookup item
 * Note: sortOrder is not included - use reorder endpoint for ordering changes
 */
export interface UpdateLookupRequest {
  name: string;
  isActive: boolean;
}

/**
 * Request payload for reordering lookup items
 */
export interface ReorderLookupsRequest {
  ids: number[];
}

/**
 * Available lookup types in the system
 */
export type LookupType = 'damage-types' | 'referral-types' | 'cost-categories' | 'payment-types' | 'insurance-companies';

/**
 * Configuration for a lookup type tab
 */
export interface LookupTypeConfig {
  type: LookupType;
  label: string;
  description: string;
}

/**
 * Lookup type configurations for display
 */
export const LOOKUP_TYPE_CONFIGS: LookupTypeConfig[] = [
  {
    type: 'damage-types',
    label: 'Damage Types',
    description: 'Types of damage for jobs (e.g., Fire, Water, Storm)',
  },
  {
    type: 'referral-types',
    label: 'Referral Types',
    description: 'How leads are referred to the company',
  },
  {
    type: 'cost-categories',
    label: 'Cost Categories',
    description: 'Categories for job costs (e.g., Labor, Materials)',
  },
  {
    type: 'payment-types',
    label: 'Payment Types',
    description: 'Types of payments accepted (e.g., Cash, Check, Card)',
  },
  {
    type: 'insurance-companies',
    label: 'Insurance Companies',
    description: 'Insurance companies referenced across leads',
  },
];
